import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundaryReactRouter';
import { convertRouteModule } from '@/utils/convert-route-module';
import { RouteObject } from 'react-router';

const paymentAccountModalRoutes: RouteObject[] = [
  {
    path: 'about',
    lazy: () => import('@/views/payments/components/shared/AboutDialog').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'create',
    lazy: () =>
      import('@/views/payments/components/shared/CreateAccountModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: ':accountId/edit',
    lazy: () =>
      import('@/views/payments/components/shared/EditAccountModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: ':accountId/admins',
    lazy: () =>
      import('@/views/payments/components/shared/ManageAdminsModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
];

export { paymentAccountModalRoutes };
